import {  Component,  OnInit, ChangeDetectorRef} from '@angular/core';
import {  FacilityService,  EquipmentService,  ModelService, MessageService} from 'src/app/services';
import {  SelectItem,  SortEvent} from 'primeng/api';
import { SelectedEquipmentInfo,  EquipmentStatusInfo } from 'src/app/models/equipments/EquipmentInfo'
import {  AccessUserInfo, UserLocationFacility} from 'src/app/models';

@Component({
  selector: 'bart-mass-update',
  templateUrl: './mass-update.component.html',
  styleUrls: ['./mass-update.component.scss']
})
export class MassUpdateComponent implements OnInit {  
  userDetail: any = null;
  first: number = 0;
  public isDisabled: boolean=false;
  public success: number;
  loading = false;
  public equipmentLocationId: number;
  public cols: any[];
  public selectedcols: any[];
  public facilityObj: object;
  public objFacilityEquipment: object;
  public disableManufacturerDropdown: boolean;
  public disableModelDropdown: boolean;
  public disableSerialNumber: boolean;
  public disableBtnSearch: boolean;
  public disableUpdateSelectedDevicesBtn: boolean;
  public equipmentStatus: boolean;

  public searchBarcollapsed: boolean = false;
  public equipmentResultCollapsed: boolean = true;
  public equipmentSelectedCollapsed: boolean = false;

  public divEquipmentResult: boolean = false;
  public divEquipmentSelected: boolean;
  IsUpdateSelectedDeviceClicked: boolean = false;
  
  public objModels: object;
  public displayModal: boolean;
  public Content: string;
  public userFacilities: SelectItem[];
  public modelList: SelectItem[];
  model: any[];
  public equpmentManufacturerId: number;
  public facilityMasterId: number;
  public modelId: number;
  public serialNumber: string;
  public selectEquipmentStatusId: number;

  public CurrentEquipmentStatusId: number;
  public CurrentEquipmentStatusId1: number[];
  public SelectedEquipments: any;
  public selectedData: any[];
  //Equipment Status
  public equipmentStatusList: SelectItem[];
  public selectedEquipmentStatusList: SelectItem[];
  public manufacturerList: SelectItem[];
  public equipmentManufactureList: SelectItem[];
  public facilityEquipmentDataSource: any[];
  public totalRecords = 0;
  public objsearchEquipment: object;
  strSelectedData: string;

  //Selected Equipment Table
  SelectedRowData: SelectedEquipmentInfo[];
  public dataSourcSelectedEquipment: any[];
  public equipmentStatusInfo: EquipmentStatusInfo[] = [];

  constructor(private facilityService: FacilityService, private equipmentService: EquipmentService,
     private modelService: ModelService, private changeDetectorRef: ChangeDetectorRef , private messageService: MessageService) {
    this.userDetail = AccessUserInfo.getUserInfo();
  }

  ngOnInit() {

    this.searchBarcollapsed = false;
    this.equipmentResultCollapsed = true;
    this.equipmentSelectedCollapsed = true;

    this.IsUpdateSelectedDeviceClicked = false;
    this.disableUpdateSelectedDevicesBtn = true;
    this.equipmentStatus = false;
    this.disableSerialNumber = true;
    this.disableBtnSearch = true;
    this.disableManufacturerDropdown = true;  
    this.disableModelDropdown = true;
    //Get Equipment Status
    this.modelId = 0;
    this.GetEquipmentStatus();

    this.cols = [{
        field: 'EquipmentID',
        header: 'Equipment Id',
        display: 'none'
      },
      {
        field: 'ManufacturerName',
        header: 'Manufacturer',
        display: 'table-cell'
      },
      {
        field: 'modelNumber',
        header: 'Model',
        display: 'table-cell'
      },
      {
        field: 'EquipmentSerialNumber',
        header: 'Serial #',
        display: 'table-cell'
      },
      {
        field: 'MPI',
        header: 'MPI',
        display: 'table-cell'
      },
      {
        field: 'EquipmentTypeDescription',
        header: 'Equip Type',
        display: 'table-cell'
      },
      {
        field: 'status',
        header: 'Status',
        display: 'table-cell'
      },
      {
        field: 'status',
        header: 'Current Status',
        display: 'none'
      },
      {
        field: 'locationtypeid',
        header: 'Location Typeid',
        display: 'none'

      }
    ];
    this.getUserFacilities();
  }

  public getUserFacilities() {   
      this.loading = true;
      this.facilityService.getUserLocationFacilities(this.userDetail.userName,(facilities:UserLocationFacility[])=>
      {
        this.userFacilities = []
        if(facilities)
        {
          this.userFacilities.push({
            label: '- Pick a Location -',
            value: 0
          });
          for (let c of facilities) {

            this.userFacilities.push({
              label: c.FacilityDisplayName,
              value: c.FacilityMasterID
            });
          }
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }    
        }
        this.loading = false;
      });
  }

  getModelDropDown(modelsObj: any) {
    this.loading = true;
    this.modelId=0;
    this.modelService.getModels(JSON.stringify(modelsObj)).subscribe((modelResponse: any) => {      
      if (modelResponse.models.length > 0) {
        this.modelList = [];
        this.modelList.push({
          label: '- Pick a Model -',
          value: 0
        });
        for (let m of modelResponse.models) {
          if(m.modelid!=null)
          {
            this.modelList.push({
              label: m.modelnumber,
              value: m.modelid
            });
          }
        }
        this.loading = false;
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
      } else {
        this.modelList = null;
        this.loading = false;
        this.modelList = [];
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
      }
    }, (respose: Response) => {
      this.modelList = [];
      this.loading = false;
      // handle error here
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  GetEquipmentStatus() {
    this.equipmentService.getEquipmentStatus().subscribe((allEquipmentStatusResponse: any) => {
      if (allEquipmentStatusResponse.status.length > 0) {
        this.equipmentStatusList = [];
        this.equipmentStatusList.push({
          label: '- Status -',
          value: -1
        });
        for (let s of allEquipmentStatusResponse.status) {
          this.equipmentStatusList.push({
            label: s.EquipmentStatusDescription,
            value: s.EquipmentStatusId            
          });
        }
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
      } else {
        this.equipmentStatusList = null;
        //this.loading = false;
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
      }
    }, (respose: Response) => {
      this.equipmentStatusList = [];
      // handle error here
    });
  }
  getFacilityEquipmentManufacturer(facilityEquipmentObj: object) {    
    this.equipmentManufactureList = [];
    this.modelList=[];
    this.equpmentManufacturerId=0;
    this.modelId=0;
    if(facilityEquipmentObj){
    this.equipmentService.getFacilityEquipmentList(JSON.stringify(facilityEquipmentObj))
      .subscribe((getManufacturersResponse: any) => {       
        this.equipmentManufactureList = [];
        if (getManufacturersResponse.facilityEquipment.length > 0)
         {
          this.equipmentManufactureList.push({
            label: '- Manufacturer -',
            value: 0
          });
          this.modelList.push({
            label: '- Pick a Model -',
            value: 0
          });
          const map = new Map();
          //Bind Facility Models
          let objManufacturerList=getManufacturersResponse.facilityEquipment;
           objManufacturerList=objManufacturerList.sort((a, b) => a.ManufacturerName.localeCompare(b.ManufacturerName)); 
          for (const item of objManufacturerList)
          {
            //if (!map.has(item.ManufacturerId)) 
            if(!this.equipmentManufactureList.filter(x=>x.value==item.ManufacturerId).length)
            {
              map.set(item.ManufacturerId, true); // set any value to Map
              this.equipmentManufactureList.push({
                label: item.ManufacturerName,
                value: item.ManufacturerId
              });
            }
          }

          //Bind Facility Models
          let objModelList=getManufacturersResponse.facilityEquipment;
          objModelList=objModelList.sort((a, b) => a.ModelNumber.localeCompare(b.ModelNumber)); 
          for (const item of objModelList)
          {
            if(!this.modelList.filter(x=>x.value==item.ModelId).length)
            {
              this.modelList.push({
                label: item.ModelNumber,
                value: item.ModelId
              });
            }
          }
          //this.modelList=this.modelList.sort((a, b) => a.label.localeCompare(b.label)); 
          
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
        } else {
          this.equipmentManufactureList = [];
          //this.loading = false;
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
        }
      }, (respose: Response) => {
        this.equipmentStatusList = [];
        this.modelList=[];
        // handle error here
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
      });
  }
}

  onUserFacilitiesChange(event: any) {
    this.facilityMasterId = event.value;

    this.objFacilityEquipment = {
      "GETFACILITYEQUIPMENTLIST": {
        "facilityMasterId": this.facilityMasterId
      }
    };

    this.equpmentManufacturerId = 0;
    this.getFacilityEquipmentManufacturer(this.objFacilityEquipment);

    if(this.facilityMasterId>0)
    {
      this.disableManufacturerDropdown = false;
      this.disableBtnSearch = false;
      this.disableModelDropdown = false;
      this.disableSerialNumber = false
    }
    else
    {
      this.disableManufacturerDropdown = true;
      this.disableBtnSearch = true;
      this.disableModelDropdown = true;
      this.disableSerialNumber = true
    }
   
  }

  onManufacturerChange() {
    this.objModels = {
      "GETMODELS": {
        "manufacturerId": this.equpmentManufacturerId,
        "equipmentTypeId": null,
        "SearchTerm": null,
        "modelsOnly": null
      }
    };

    this.modelId = null;
    this.modelList = [];
    this.getModelDropDown(this.objModels);
  }
  searchFacilityEquipment() {    
    this.objsearchEquipment = {
      "GETFACILITYEQUIPMENTMANAGER": {
        "facilityMasterIdList": this.facilityMasterId,
        "manufacturerId": this.equpmentManufacturerId,
        "modelId": this.modelId,
        "serialNumber": this.serialNumber,
        "Username": this.userDetail.userName
      }
    };
    this. facilityEquipmentDataSource=[];
    this.GetEquipmentStatus();
    this.selectedData = null;
    //this.facilityEquipmentDataSource = [];
    this.GetFacilityEquipment(this.objsearchEquipment);    

    this.divEquipmentResult = true;
    //this.disableUpdateSelectedDevicesBtn = true;
    this.equipmentStatus = false;

    this.searchBarcollapsed = true;
    this.equipmentResultCollapsed = false;
    this.equipmentSelectedCollapsed = false;
    this.serialNumber = "";
    this.divEquipmentSelected= false;
    //this.disableUpdateSelectedDevicesBtn=false;

    if(this.facilityMasterId>0)
    {
      this.disableManufacturerDropdown = false;
      this.disableBtnSearch = false;
      this.disableModelDropdown = false;
      this.disableSerialNumber = false
    }
    else
    {
      this.disableManufacturerDropdown = true;
      this.disableBtnSearch = true;
      this.disableModelDropdown = true;
      this.disableSerialNumber = true
    } 
  }

  GetFacilityEquipment(searchEquipmentObj: object) {
    if (searchEquipmentObj !== null) {
      this.loading = true;
      this.equipmentService.getFacilityEquipmentManager(JSON.stringify(searchEquipmentObj))
        .subscribe((facilityEquipmentResponse: any) => {
          this.facilityEquipmentDataSource = [];          
          if (facilityEquipmentResponse.facilityEquipment.length > 0) {
            this.divEquipmentResult = true;
            this.facilityEquipmentDataSource = facilityEquipmentResponse.facilityEquipment;
            this.loading = false;
            if (!this.changeDetectorRef['destroyed']) {
              this.changeDetectorRef.detectChanges();
            }
          } else {
            this.facilityEquipmentDataSource = null;
            this.loading = false;
            this.divEquipmentResult = true;
            if (!this.changeDetectorRef['destroyed']) {
              this.changeDetectorRef.detectChanges();
            } 
          }
        }, (respose: Response) => {         
          this.facilityEquipmentDataSource = [];
          this.loading = false;
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
          // handle error here
        });
    }

    if(this.facilityMasterId>0)
            {
              this.disableManufacturerDropdown = false;
              this.disableBtnSearch = false;
              this.disableModelDropdown = false;
              this.disableSerialNumber = false
            }
            else
            {
              this.disableManufacturerDropdown = true;
              this.disableBtnSearch = true;
              this.disableModelDropdown = true;
              this.disableSerialNumber = true
            }
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (event.order * result);
    });
  }

  onClickUpdateSelectedDevicesBtn() {
      this.disableUpdateSelectedDevicesBtn = true;
      this.equipmentStatus = true;
      this.IsUpdateSelectedDeviceClicked = true;
      this.equipmentResultCollapsed = true;
      this.equipmentSelectedCollapsed = false;
      this.searchBarcollapsed = true;
      this.divEquipmentSelected =true;     
      this.isDisabled=true; 
     
      for(let i=0; i<this.selectedData.length;i++)
      {
        this.selectedData[i].equipmentstatusid=this.selectEquipmentStatusId;
      }
  }

  onClickAddDeviceBtn() {
    this.equipmentResultCollapsed = false;
    this.equipmentSelectedCollapsed = true;
    this.equipmentStatus = false;
    this.disableUpdateSelectedDevicesBtn = false;
    this.isDisabled=false;
  }
  public successCount = 0;
  public failCount = 0;
  public skipCount = 0;

  onClickcompleteUpdateBtn() {    
    this.successCount = 0;
    //this.facilityMasterId=0;
    this.failCount = 0;
       this.equipmentStatusInfo = this.selectedData.map(data => ({
      equipmentid: data.EquipmentID,
      locationtypeid: data.locationtypeid,
      datemodified: null,
      userid: this.userDetail.userId,
      equipmentstatusid: data.equipmentstatusid,
      locationdescription: "Status Change",
      facilitymasterid: this.facilityMasterId
    })) as EquipmentStatusInfo[];
 
    let locationTypeid=0
    let temp =this.equipmentStatusInfo.filter(x => x.equipmentstatusid == -1);
    if( temp.length > 0 )
    {  
      this.messageService.showAlertMessage("Please select status!");

      return;
    }

    for(let i=0; i<this.equipmentStatusInfo.length; i++){

       locationTypeid=this.equipmentStatusInfo[i].locationtypeid
 
      if(locationTypeid==null || locationTypeid==0)
      {
          let ObjEquipmentId = {
            "GETEQUIPMENTLOCATIONID": {
              "equipmentId": this.equipmentStatusInfo[i].equipmentid,
            }
          }
           this.getEquipmentLocationId(ObjEquipmentId);
           locationTypeid=this.equipmentLocationId
      }
     
        let ObjEquipmentStatus = {
          "UPDATEEQUIPMENTLOCATION": {
            "EQUIPMENTID": this.equipmentStatusInfo[i].equipmentid, 
            "LOCATIONTYPEID": "",
            //"DATEMODIFIED": this.equipmentStatusInfo[i].datemodified, 
            "USERID": this.equipmentStatusInfo[i].userid, 
            "EQUIPMENTSTATUSID": this.equipmentStatusInfo[i].equipmentstatusid, 
            "LOCATIONDESCRIPTION": this.equipmentStatusInfo[i].locationdescription, 
            "FACILITYMASTERID": this.equipmentStatusInfo[i].facilitymasterid 
          },
          "GETEQUIPMENTSTATUSID": {
            "EQUIPMENTID": this.equipmentStatusInfo[i].equipmentid 
          },
          "GETEQUIPMENTLOCATIONID": {
            "EQUIPMENTID": this.equipmentStatusInfo[i].equipmentid,
          },
          "UPDATEEQUIPMENTSTATUS": {
            "EQUIPMENTID": this.equipmentStatusInfo[i].equipmentid, 
            "USERID": this.equipmentStatusInfo[i].userid,
            "EQUIPMENTSTATUSID": this.equipmentStatusInfo[i].equipmentstatusid 
          }
        };

         this.updateEquipmentStatus(ObjEquipmentStatus,()=>
         {            
             if((this.successCount + this.failCount) == (this.equipmentStatusInfo.length))
             {
                if(this.successCount > 0)
                  this.Content = this.successCount + " update(s) successful.";
                  this.displayModal = true;

              if(this.failCount>0)
                  this.Content+= this.failCount + " update(s) failed.";
              this.displayModal = true;
             }
         });
    }

    this.searchBarcollapsed = false;
    this.equipmentResultCollapsed= true;
    this.equipmentSelectedCollapsed = false;

    this.IsUpdateSelectedDeviceClicked = false;

    this.divEquipmentResult = false;
    this.divEquipmentSelected= false;

    //this.disableBtnSearch=false;  
    this.isDisabled=false;
    this.getUserFacilities();
    //this.GetEquipmentStatus();   
    this.selectEquipmentStatusId=null;

    if(this.facilityMasterId>0)
    {
      this.disableManufacturerDropdown = false;
      this.disableBtnSearch = false;
      this.disableModelDropdown = false;
      this.disableSerialNumber = false
    }
    else
    {
      this.disableManufacturerDropdown = true;
      this.disableBtnSearch = true;
      this.disableModelDropdown = true;
      this.disableSerialNumber = true
    } 
  }

  public updateEquipmentStatus (equipmentStatusObj: any,callback) {

    if (equipmentStatusObj != null) {

      this.loading = true;
      this.equipmentService.updateEquipmentStatus(JSON.stringify(equipmentStatusObj))
        .subscribe((result: any) => {           
            this.loading = false;
            this.successCount++           
            callback();
            if (!this.changeDetectorRef['destroyed']) {
              this.changeDetectorRef.detectChanges();
            }

          } ,
          (error) => {
            this.failCount++
            this.loading = false;
            if (!this.changeDetectorRef['destroyed']) {
              this.changeDetectorRef.detectChanges();
            }

            this.Content = "update(s) Failed.";
            this.displayModal = true;
          }
        );
    }
    
  }
  closeClick(eventId: string) {
    this.displayModal = false;
  }

  public getEquipmentLocationId(equObj: object) {
    this.equipmentService.getEquipmentLocationId(JSON.stringify( equObj)).subscribe((equipmentLocationIdResponse: any) => {
     
      if (equipmentLocationIdResponse.getLocId.length > 0) {
        this.equipmentLocationId = equipmentLocationIdResponse.getLocId[0].locationTypeId;

      } else {
        this.equipmentLocationId = 0;
      }
    }, (respose: Response) => {
      this.equipmentLocationId = 0;
      // handle error here
    });
  }

  onCurrentEquipmentStatusChange(event: any) {



if(this.selectEquipmentStatusId== -1)
{
    this.disableUpdateSelectedDevicesBtn = true;
}
else
{this.disableUpdateSelectedDevicesBtn = false;}

  }
  
  
    reset() {
      this.first = 0;
    }
}
